<div class="d-flex file-container">
  <div class="selected-file" [class.disabled]="disabled" [class.error]="hasError">
    <div class="file-info-container">
      <div class="d-flex align-items-center gap-2 file-info">
        <div class="thumbnail" *ngIf="showThumbnailBox$ | async">
          <lib-loading-shimmer *ngIf="showThumbnailShimmer$ | async" [height]="'2.5rem'" [width]="'2.5rem'" />
          <img
            *ngIf="showThumbnailImage$ | async"
            class="thumbnail-image"
            [class.disabled]="disabled"
            [src]="thumbnailUrl$ | async"
            (error)="onThumbnailError()"
            alt="" />
          <img
            *ngIf="showThumbnailFallback$ | async"
            class="thumbnail-image thumbnail-fallback"
            [class.disabled]="disabled"
            [src]="thumbnailFallbackSrc"
            alt="" />
        </div>
        <span class="file-name" [class.disabled]="disabled" [title]="fileName">
          <span class="file-name-base">{{ fileNameBase$ | async }}</span>
          <span class="file-name-extension">{{ fileNameExtension$ | async }}</span>
        </span>
      </div>
      <span class="file-size" [class.disabled]="disabled">{{ fileSizeString$ | async }}</span>
    </div>
    <div class="option-buttons">
      <button
        *ngIf="showPreview"
        type="button"
        class="no-style-button preview"
        [class.error]="hasError"
        [disabled]="disabled || !(previewAvailable$ | async)"
        (click)="onPreviewClick()">
        {{ previewLabel }}
      </button>
      <button
        *ngIf="action === 'download'"
        type="button"
        class="no-style-button download"
        [disabled]="disabled"
        (click)="downloadClicked.emit()">
        <img [src]="'assets/icons/blue/Download.svg'" alt="Download" i18n-alt />
      </button>
      <button
        *ngIf="action === 'remove'"
        [disabled]="disabled"
        class="no-style-button close-button"
        type="button"
        (click)="removeClicked.emit()">
        <img [src]="closeIconSrc$ | async" alt="Close" i18n-alt />
      </button>
    </div>
  </div>
</div>
